import { z } from "zod";
import { mustBeHexadecimal } from "../../../../providers/zod-rules.provider";

export const FormPrSizeLabeler = z.object({
  enabled: z.boolean(),
  settings: z.object({
    labels: z.object({
      tiny: z.object({
        label: z.string().nonempty("Field is empty"),
        color: mustBeHexadecimal,
      }),
      small: z.object({
        label: z.string().nonempty("Field is empty"),
        color: mustBeHexadecimal,
      }),
      medium: z.object({
        label: z.string().nonempty("Field is empty"),
        color: mustBeHexadecimal,
      }),
      large: z.object({
        label: z.string().nonempty("Field is empty"),
        color: mustBeHexadecimal,
      }),
      huge: z.object({
        label: z.string().nonempty("Field is empty"),
        color: mustBeHexadecimal,
      }),
    }),
    repositories: z.array(z.any()),
  }),
});

export type FormPrSizeLabeler = z.infer<typeof FormPrSizeLabeler>;
